import React from "react";
import { NavLink } from "react-router-dom";
import ContactHeaderImage from "../../assets/images/login/contact-us.png";
const BannerSection = () => {
  return (
    <>
      <section className="contact-banner">
        <div className="max-container">
          <div className="padd-90">
            <div className="grid-auto-fit align-items-center max-width950">
              <div>
                <h1 className="heading39px roboto-bold mb20 text-color-131415">
                  CONTACT US
                </h1>
                <p className="heading16px roboto-regular mb30">
                  We're excited to hear from you - let's discuss something
                  awesome!
                </p>

                <ul className="btn-sec">
                  <li>
                    <NavLink
                      to={"/signup"}
                      className="common-btn-class main-btn-primary roboto-regular"
                    >
                      Start Free Trial
                    </NavLink>
                  </li>
                </ul>
              </div>
              <div className="text-center">
                <img
                  src={ContactHeaderImage}
                  className="img-responsive"
                  alt="Our FAQs"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default BannerSection;
